import type { CustomToastPosition, ToastOptions } from "#shared/types";

const TOP_MARGIN = 20;
const RIGHT_MARGIN = 20;

type ToastType = "success" | "error" | "info" | "warning" | "custom";

export const useNotification = () => {
  const toast = useToast();

  const showToast = (
    type: ToastType,
    title: string,
    message: string,
    options: ToastOptions = {}
  ): void => {
    const position = options.position || {};

    const parsedPosition = {
      top: position.top ?? TOP_MARGIN,
      right: position.right ?? RIGHT_MARGIN,
      ...(position.bottom !== undefined && { bottom: position.bottom }),
      ...(position.left !== undefined && { left: position.left }),
    };

    toast.custom({
      type,
      title,
      message,
      duration: options.duration,
      bordered: options.bordered,
      position: parsedPosition,
    });
  };

  return {
    showSuccessToast: (
      title: string,
      message: string,
      bordered?: boolean
    ): void => showToast("success", title, message, { bordered }),

    showErrorToast: (
      title: string,
      message: string,
      bordered?: boolean
    ): void => showToast("error", title, message, { bordered }),

    showInfoToast: (title: string, message: string, bordered?: boolean): void =>
      showToast("info", title, message, { bordered }),

    showWarningToast: (
      title: string,
      message: string,
      bordered?: boolean
    ): void => showToast("warning", title, message, { bordered }),

    showCustomToast: (
      title: string,
      message: string,
      bordered?: boolean,
      duration?: number,
      position?: CustomToastPosition
    ): void =>
      showToast("custom", title, message, { bordered, duration, position }),
  };
};
